<div class="header">
    <h2>{{ 'users.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="users-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'users.error.unavailable' | translate" />
} @else if (user(); as user) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'users.fieldset.personal' | translate }}</h2>
            <div class="profile">
                <app-form-avatar
                    [control]="form.controls.avatarId"
                    [label]="'users.form.avatar' | translate"
                    inputId="avatar"
                    [accept]="['image/*']"
                    testId="users-edit-avatar"
                />
                <div class="fields">
                    <div class="row">
                        <app-form-input
                            [control]="form.controls.firstName"
                            [label]="'users.form.firstName' | translate"
                            inputId="firstName"
                            testId="users-edit-first-name"
                        />
                        <app-form-input
                            [control]="form.controls.lastName"
                            [label]="'users.form.lastName' | translate"
                            inputId="lastName"
                            testId="users-edit-last-name"
                        />
                    </div>
                    <app-form-input
                        [control]="form.controls.email"
                        [label]="'users.form.email' | translate"
                        type="email"
                        inputId="email"
                        testId="users-edit-email"
                    />
                </div>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'users.fieldset.account' | translate }}</h2>
            <div class="access">
                <div class="status" data-test="users-edit-status">
                    <p-tag
                        [value]="(user.activated ? 'users.access.status.activated' : 'users.access.status.awaiting') | translate"
                        [severity]="user.activated ? 'success' : 'warn'"
                        [icon]="user.activated ? 'pi pi-check-circle' : 'pi pi-clock'"
                    />
                    @if (user.lastSentEmailAt) {
                        <small>{{ 'users.access.lastSent' | translate }} {{ user.lastSentEmailAt | date: 'medium' }}</small>
                    }
                </div>
                <app-access-button [user]="user" [emailEdited]="emailEdited()" testId="users-edit-access" />
            </div>
        </div>

        <div class="section">
            <h2>{{ 'users.fieldset.roleLocation' | translate }}</h2>
            <div class="row">
                <app-form-select
                    [control]="form.controls.role"
                    [label]="'users.form.role' | translate"
                    [options]="roleOptions"
                    inputId="role"
                    testId="users-edit-role"
                />
                <app-form-select
                    [control]="form.controls.country"
                    [label]="'users.form.country' | translate"
                    [options]="countryOptions"
                    [filter]="true"
                    inputId="country"
                    testId="users-edit-country"
                />
            </div>
            @if (isOrganisationAdmin()) {
                <app-form-select
                    [control]="form.controls.organisationId"
                    [label]="'users.form.organisation' | translate"
                    [placeholder]="'users.form.organisation.placeholder' | translate"
                    [options]="organisationOptions()"
                    [filter]="true"
                    inputId="organisationId"
                    testId="users-edit-organisation-id"
                />
            } @else {
                <app-form-select
                    [control]="form.controls.schoolId"
                    [label]="'users.form.school' | translate"
                    [placeholder]="'users.form.school.placeholder' | translate"
                    [options]="schoolOptions()"
                    [filter]="true"
                    inputId="schoolId"
                    testId="users-edit-school-id"
                />
            }
            @if (isSchoolAdmin()) {
                <app-form-input
                    [control]="form.controls.contactEmail"
                    [label]="'users.form.contactEmail' | translate"
                    type="email"
                    inputId="contactEmail"
                    testId="users-edit-contact-email"
                />
            }
        </div>

        <div class="section">
            <h2>{{ 'users.fieldset.details' | translate }}</h2>
            <app-form-textarea
                [control]="form.controls.description"
                [label]="'users.form.description' | translate"
                inputId="description"
                testId="users-edit-description"
            />
        </div>

        <div class="section">
            <h2>{{ 'users.fieldset.password' | translate }}</h2>
            <app-form-password
                [control]="form.controls.password"
                [label]="'users.form.password' | translate"
                [placeholder]="'users.form.password.placeholder' | translate"
                inputId="password"
                testId="users-edit-password"
            />
        </div>
    </form>

    <div class="footer">
        <p-button [label]="'users.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="users-edit-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'users.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="users-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
